import { Address } from '@matech/thebigpos-sdk'

import { concatStrings } from '../../../../services/helpers'

const formatBorrowerAddress = (address?: Address | null) => {
	if (!address) {
		return []
	}

	const streetLine = concatStrings(
		address.street,
		address.unit
	).getValue()

	const statePostalCode = concatStrings(
		address.state,
		address.postalCode
	).getValue()

	const cityStateZipCodeLine = concatStrings(
		address.city,
		statePostalCode
	)
		.setDelimiter(', ')
		.getValue()

	const firstLine = streetLine
	const secondLine = cityStateZipCodeLine

	return [firstLine, secondLine].filter((item) => Boolean(item))
}

export default formatBorrowerAddress
